"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Card = _interopRequireDefault(require("../Card"));
var _MaterialIcon = _interopRequireDefault(require("../MaterialIcon"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styled = require("./styled");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const InfoList = _ref => {
  let {
    cardHeight = 'auto',
    height = 'auto',
    icon,
    items = [],
    margin = '0px',
    title,
    width = '100%'
  } = _ref;
  const cardProps = {
    cardHeight,
    margin,
    padding: '5px',
    width
  };
  const containerProps = {
    height
  };
  const iconProps = {
    icon
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Card.default, _objectSpread(_objectSpread({}, cardProps), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.Container, _objectSpread(_objectSpread({}, containerProps), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.Title, {
        children: [!!icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MaterialIcon.default, _objectSpread({}, iconProps)), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: title
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Content, {
        children: items.map((_ref2, index) => {
          let {
            label,
            value
          } = _ref2;
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.InfoRow, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.InfoData, {
              children: label
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.InfoSeparator, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.InfoData, {
              children: value
            })]
          }, index);
        })
      })]
    }))
  }));
};
InfoList.propTypes = {
  caption: _propTypes.default.string,
  cardHeight: _propTypes.default.string,
  height: _propTypes.default.string,
  icon: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
  })),
  margin: _propTypes.default.string,
  title: _propTypes.default.string,
  width: _propTypes.default.string
};
var _default = exports.default = InfoList;